import { notification } from 'antd';
import { ApplicationStatus } from '../types';
import { captureEvent } from '../services/analytics';
import {
  hasSeenRejectionEncouragement,
  markRejectionEncouragementSeen,
} from './replyCaptureStorage';

/**
 * Calm, one-time reassurance shown on the user's FIRST application rejection —
 * whether it was auto-detected from email (ApplicationStatusNotifier) or set by
 * hand via the Applications status dropdown (handleUpdateStatus). Shared so both
 * paths use the same copy, the same first-time cap, and the same analytics, and
 * so the cap dedupes across paths (a manual reject followed by a later auto-detect
 * won't show it twice).
 *
 * Fires only for a `rejected` status (never `withdrawn` — a user's own choice),
 * at most once per account, and only while the tab is visible: an auto-detected
 * rejection can arrive over SSE while the tab is backgrounded, where the toast
 * would auto-dismiss unseen — so we hold the one-shot for a rejection the user is
 * actually present for.
 */
export const maybeShowRejectionEncouragement = (
  newStatus: ApplicationStatus | undefined,
  applicationId?: string | null
): void => {
  if (newStatus !== 'rejected') return;
  if (hasSeenRejectionEncouragement()) return;
  if (document.visibilityState !== 'visible') return;

  markRejectionEncouragementSeen();
  captureEvent('rejection_encouragement_shown', {
    application_id: applicationId ?? null,
  });

  notification.info({
    message: 'A "no" here is normal',
    description: (
      <div style={{ fontSize: 13, color: '#444a58', lineHeight: 1.5 }}>
        Most interviews take 10–20 outreaches,
        <br />
        sometimes more.
        <br />
        <br />
        You're not off track.
      </div>
    ),
    placement: 'topRight',
    duration: 12,
  });
};
